import { useAtomValue } from 'jotai';
import { protectedRouteListAtom } from './app-config.state';

export const useAppConfig = () => {
  const protectedRoutes = useAtomValue(protectedRouteListAtom);

  return {
    protectedRoutes,
  };
};
